import "../scss/styles.scss";
import PageCommon from "./pages/PageCommon.js";
import PageGeneric from "./pages/PageGeneric.js";
import PageDefault from "./pages/PageDefault.js";
import PageAroundTheBlog from "./pages/PageAroundTheBlog.js";
import PageProductList from "./pages/PageProductList.js";
import PageSearch from "./pages/PageSearch.js";
import PageHome from "./pages/PageDefault.js";
import PageIntro from "./pages/PageIntro.js";
import ServiceManager from "./3x1010/services/ServiceManager.js"

export default class FactoryManager {
	static factory(cls) {
		return new FactoryManager.classes[cls]();
	}
}

FactoryManager.classes = { PageCommon, PageAroundTheBlog, PageProductList, PageSearch, PageHome, PageIntro, PageDefault, PageGeneric };
window.Class = {};
window.Class.ServiceManager = ServiceManager;
window.Class.PageCommon = PageCommon;